var categoryToString = function categoryToString(category, subcategory) {
  if (!category || !subcategory) {
    return undefined;
  }
  return "".concat(category, "/").concat(subcategory);
};
export default categoryToString;